import { Stack, Typography, useTheme } from "@mui/material";
import { usePropertyContext } from "../context/usePropertyContext";
import { WhiteBox, FoodsIconButton } from "@foodpilot/foods";
import { sanitizeFilename } from "../context/utils/sanitizeFilename";

export const TemporaryFile = () => {
    const theme = useTheme();

    const { attachmentState, post } = usePropertyContext();

    const canAnswerSsq = post.canAnswerSsq;
    const { temporaryFiles, removeTemporaryFile } = attachmentState;

    if (temporaryFiles.length === 0) {
        return null;
    }

    return (
        <Stack width={"100%"} gap={theme.spacing(1)} alignItems={"center"}>
            {temporaryFiles.map((file, index) => (
                <WhiteBox
                    key={`${file.name}-${file.lastModified}-${index}`}
                    sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        overflowWrap: "anywhere",
                        border: `dashed ${theme.palette.grey[500]}`,
                    }}
                    padding={theme.spacing(2)}
                    alignItems="center"
                    borderRadius={theme.spacing(1)}
                >
                    <Typography variant="body-medium" sx={{ color: theme.custom.grey[2000] }}>
                        {sanitizeFilename(file.name)}
                    </Typography>
                    {canAnswerSsq && (
                        <FoodsIconButton
                            size="s"
                            icon="delete"
                            buttonProps={{
                                onClick: () => removeTemporaryFile(index),
                            }}
                        />
                    )}
                </WhiteBox>
            ))}
        </Stack>
    );
};
